import { NumberInput } from "@mantine/core";

import classes from "./index.module.css";

interface ICalculatorInput {
  allowDecimal?: boolean;
  disabled?: boolean;
  max?: number;
  min?: number;
  rightSection: any;
  rightSectionWidth: number;
  label?: string;
  variant?: string;
}

const CalculatorInput = ({
  rightSection,
  rightSectionWidth,
  min,
  max,
  allowDecimal,
  disabled,
  variant = "",
  label,
  ...props
}: ICalculatorInput) => {
  return (
    <NumberInput
      classNames={{
        wrapper: classes.wrapper,
        input: `${classes.input} ${classes[variant]}`,
        error: classes.error,
        section: classes.section,
      }}
      rightSection={rightSection}
      rightSectionWidth={rightSectionWidth}
      min={min}
      max={max}
      allowDecimal={allowDecimal}
      disabled={disabled}
      aria-label={label}
      {...props}
    />
  );
};

export default CalculatorInput;
